export const TICKER_COUNTRY_OPTIONS = [
  { label: "GN - Guinea", value: "GN" },
  { label: "LR - Liberia", value: "LR" },
  { label: "CI - Cote d'Ivoire", value: "CI" },
  { label: "SL - Sierra Leone", value: "SL" },
];

export const getCountryLabel = (countryCode) => {
  const option = TICKER_COUNTRY_OPTIONS.find(
    (country) => country.value === countryCode,
  );
  return option?.label ?? countryCode;
};
